package com.arena_web.data.repository

import com.arena_web.data.api.UserStoryApi
import com.arena_web.data.dto.CreateUserStoryRequest
import com.arena_web.data.dto.FeedStoryAuthorGroupPageDto
import com.arena_web.data.dto.ImageUploadResponse
import com.arena_web.data.dto.StoryViewerDto
import com.arena_web.data.dto.UserStoryDto
import com.arena_web.domain.repositories.UserStoryRepository

class UserStoryRepositoryImpl(private val storyApi: UserStoryApi) : UserStoryRepository {

    override suspend fun getMyStories(): Result<List<UserStoryDto>> =
        apiCall { storyApi.getMyStories() }

    override suspend fun getStoriesByUser(userId: String): Result<List<UserStoryDto>> =
        apiCall { storyApi.getStoriesByUser(userId) }

    override suspend fun getActiveFeedStories(): Result<List<UserStoryDto>> =
        apiCall { storyApi.getActiveFeedStories() }

    override suspend fun getFeedStoryAuthors(
        params: Map<String, String>,
    ): Result<FeedStoryAuthorGroupPageDto> =
        apiCall { storyApi.getFeedStoryAuthors(params) }

    override suspend fun createStory(request: CreateUserStoryRequest): Result<UserStoryDto> =
        apiCall { storyApi.createStory(request) }

    override suspend fun deleteStory(storyId: String): Result<Unit> =
        apiCallUnit { storyApi.deleteStory(storyId) }

    override suspend fun markStorySeen(storyId: String): Result<Unit> =
        apiCall { storyApi.markStorySeen(storyId) }.map { }

    override suspend fun likeStory(storyId: String): Result<Map<String, Boolean>> =
        apiCall { storyApi.likeStory(storyId) }

    override suspend fun getStoryViewers(storyId: String): Result<List<StoryViewerDto>> =
        apiCall { storyApi.getStoryViewers(storyId) }

    override suspend fun uploadImage(
        fileBytes: ByteArray,
        fileName: String,
        contentType: String
    ): Result<ImageUploadResponse> =
        apiCall { retryOnceOnNetworkError { storyApi.uploadImage(fileBytes, fileName, contentType) } }
}
